export enum editModeKey {
    IndividualRecruiter = 1,
    AllRecruiter = 2,
    CandidateAcknResume = 3,
    CandidateAcknInfo = 4
  }